<template>
  <div>
    <div class="subtitle-2 mb-3">
      {{ $t("dangerousGoods.dangerousGoodsList.form.additionalFiles") }}
    </div>

    <v-card
      v-for="(file, index) in files"
      :key="`f${index}`"
      outlined
      class="mb-3 pa-3"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-3">mdi-paperclip</v-icon>
        <v-text-field
          :value="file.name"
          readonly
          outlined
          dense
          hide-details
          :class="{ 'file-row--link': isSaved(file) }"
          @click="downloadFile(file)"
        />
        <v-btn icon color="error" class="ml-3" @click="askRemove(index)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card>

    <v-card
      v-for="row in emptyRows"
      :key="`e${row}`"
      outlined
      class="mb-3 pa-3"
    >
      <div class="d-flex align-center">
        <v-file-input
          :label="$t('dangerousGoods.dangerousGoodsList.form.additionalFilesAdd')"
          prepend-icon="mdi-paperclip"
          outlined
          dense
          hide-details
          multiple
          :value="[]"
          @change="(list) => addFiles(list, row)"
        ></v-file-input>
        <v-btn icon color="error" class="ml-3" @click="removeEmptyRow(row)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card>

    <v-btn text color="primary" small @click="addEmptyRow">
      <v-icon small left>mdi-plus</v-icon>
      {{ $t("dangerousGoods.dangerousGoodsList.form.addFileRow") }}
    </v-btn>

    <v-dialog v-model="removeDialog.open" max-width="440">
      <v-card>
        <v-card-title>
          {{ $t("dangerousGoods.dangerousGoodsList.form.removeFileTitle") }}
        </v-card-title>
        <v-card-text>
          {{
            $t("dangerousGoods.dangerousGoodsList.form.removeFileText", {
              name: removeDialog.name,
            })
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="removeDialog.open = false">
            {{ $t("general.cancel") }}
          </v-btn>
          <v-btn color="error" @click="confirmRemove">
            {{ $t("general.delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["value", "config"],
  data: () => ({
    removeDialog: { open: false, index: null, name: "" },
    emptyRows: [],
    nextRowId: 1,
  }),
  computed: {
    files() {
      return this.value.additionalFiles || [];
    },
  },
  watch: {
    files: {
      immediate: true,
      handler(list) {
        if (!list.length && !this.emptyRows.length) this.addEmptyRow();
      },
    },
  },
  methods: {
    isSaved(file) {
      return !!(file.location && !file.content);
    },
    addEmptyRow() {
      this.emptyRows.push(this.nextRowId++);
    },
    removeEmptyRow(row) {
      this.emptyRows = this.emptyRows.filter((r) => r !== row);
    },
    async downloadFile(file) {
      const folder = this.config && this.config.downloadFolder;
      if (!folder || !this.isSaved(file)) return;
      const path = `${folder}/${file.name}_${file.location}.${file.filetype}`;
      const url = await this.$store.dispatch("getPresignedDownloadUrl", path);
      if (url) window.open(url, "_blank");
    },
    askRemove(index) {
      this.removeDialog = {
        open: true,
        index,
        name: this.files[index] ? this.files[index].name : "",
      };
    },
    confirmRemove() {
      this.removeFile(this.removeDialog.index);
      this.removeDialog.open = false;
    },
    removeFile(index) {
      const next = [...this.files];
      next.splice(index, 1);
      this.$set(this.value, "additionalFiles", next);
    },
    async addFiles(fileList, row) {
      if (!fileList || !fileList.length) return;
      const added = [];
      for (const fileObject of fileList) {
        const content = await this.readFile(fileObject);
        added.push({
          name: fileObject.name,
          filetype: fileObject.name.match(/\.[0-9a-z]+$/i)?.[0].split(".")[1],
          content,
        });
      }
      this.removeEmptyRow(row);
      this.$set(this.value, "additionalFiles", [...this.files, ...added]);
    },
    readFile(fileObject) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result.split(",")[1]);
        reader.onerror = reject;
        reader.readAsDataURL(fileObject);
      });
    },
  },
};
</script>

<style scoped>
.file-row--link >>> input {
  cursor: pointer;
}
</style>
